import styled from 'styled-components';

import { Image as ChackraImage } from '@chakra-ui/react';

export const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 16px;
`;

export const Image = styled.img`
  max-width: 166px;
`;
export const Button = styled.button`
  width: 300px;
  height: 50px;
`;

// "https://via.placeholder.com/200x60"

export const ImgLogo = styled(ChackraImage)`
  width: 200px;
  height: 150px;
  object-fit: contain;
  margin-top: -20px;
`;

export const Span = styled.span`
  margin-top: 24px;
  display: flex;
  justify-content: flex-start;
`;
